import {Directive, ElementRef, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[appOnlyDates]'
})
export class OnlyDatesDirective {
  private regex: RegExp = new RegExp(/^([0-9]{2})+(\/)+([0-9]{2})/);
  constructor(private el: ElementRef, private control: NgControl) {}
  dateAux: any;
  aux: any = 0;
  @HostListener('input', ['$event'])
  // tslint:disable-next-line:typedef
  onkeydown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.trim();
    this.control.control.patchValue(input.value);
    if (!this.regex.test(input.value)) {
      if (input.value.length > 0 && input.value.length < 3) {
        input.value = input.value.replace(/[^0-9]/g, '');
        if (input.value.length === 2 && this.aux === 0){
          input.value += '/';
          this.aux++;
        } else {
          this.aux = 0;
        }
      } else if (input.value.length > 3 && input.value.length < 6 ) {
        input.value = input.value.replace(/[^0-9/]/g, '');
      }
      this.control.control.patchValue(input.value);
    }
  }

}
